module.exports = __webpack_public_path__ + "media/images/user/rectangle-4c76ccd8e3330f330b52041b4a4e6004.svg";